export const sizes = {
   w100: 100,
   w200: 200,
   w250: 250,
   w300: 300,
   w350: 350,
   w400: 400,
   w600: 600,
   h35: 35,
};

export const periodTypes = ["Monthly", "Weekly"];

const baseUrl = process.env.REACT_APP_API_URL;

export const quotaCopyUrls = {
   userCountries: baseUrl + "GetUserCountries?",
   targetPeriods: baseUrl + "Define/GetValidityPeriods?",
   sourcePeriods: baseUrl + "Define/GetClonePeriods?",
   quotaDetails: baseUrl + "Define/GetCopySubmitQuotaDetails",
   detailQuota: baseUrl + "Define/GetQuotaCustomerBreakdown?",
   copyQuota: baseUrl + `Define/CopyQuota`,
   submitQuota: baseUrl + `Define/SubmitCopiedQuota`,
};

export function prepareQuotaDetailsTable(data) {
   const rows = getQuotaDetailsTableRow(data);
   return { rows };
}

export function getCountryIDString(selectedCountries, countries) {
   let str = "";

   if (selectedCountries.length === 1 && selectedCountries[0] === "All") {
      for (let i = 0; i < countries.length; ++i) {
         const id = countries[i].countryID;
         str += i === countries.length - 1 ? id : id + ",";
      }
      return str;
   }

   for (let i = 0; i < selectedCountries.length; ++i) {
      const country = selectedCountries[i];
      const id = countries.find((c) => c.countryName === country).countryID;
      str += i === selectedCountries.length - 1 ? id : id + ",";
   }
   return str;
}

export function getValidityDates(targetPeriods, selectedTargetPeriod) {
   const validityPeriod = targetPeriods.find(
      (p) => p.displayDate === selectedTargetPeriod
   );
   return {
      validityStartDate: validityPeriod.startDate,
      validityEndDate: validityPeriod.endDate,
   };
}

export function getCloneDates(sourcePeriods, selectedSourcePeriod) {
   const clonePeriod = sourcePeriods.find(
      (p) => p.displayDate === selectedSourcePeriod
   );
   return {
      cloneStartDate: clonePeriod.startDate,
      cloneEndDate: clonePeriod.endDate,
   };
}

function getQuotaDetailsTableRow(data) {
   let rows = [];
   for (let i = 0; i < data.length; ++i) {
      const row = {
         id: i,
         checked: false,
         scenarioName: data[i].scenarioName,
         countryName: data[i].countryName,
         criticalityId: data[i].criticalityId,
         quotaStatus: data[i].quotaStatus,
         previousTotalForecast: data[i].previousTotalForecast,
         initialForecast: data[i].initialForecast,
         totalForecast: data[i].totalForecast,
         lastActionDate: data[i].lastActionDate.toString().indexOf('9999') >= 0 ? "" : data[i].lastActionDate,
         lastActionBy: data[i].lastActionBy,
         period: data[i].period,
      };
      rows.push(row);
   }
   return rows;
}

export function prepareDetailQuotaTable(data) {
   const columns = detailQuotaTableCol();
   const rows = getDetailQuotaTableRow(data);
   return { columns, rows };
}

function detailQuotaTableCol() {
   const cols = [
      { field: "customerName", headerName: "Customer Name", width: 350 },
      { field: "customerNumber", headerName: "Customer Number", width: 200 },
      { field: "skuName", headerName: "SKU", width: 350 },
      { field: "skuNumb", headerName: "SKU Number", width: 200 },
      { field: "initialQuota", headerName: "Initial Quota", width: 120,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         }  },
      { field: "safetyMargin", headerName: "Safety Margin", width: 120,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         }  },
      { field: "adjustment", headerName: "Adjustment", width: 100,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         }  },
      { field: "totalQuota", headerName: "Total Quota", width: 100,
         valueFormatter: (params) => {
            const formattedValue = params.value?.toLocaleString();
            return formattedValue;
         }  },
   ];
   return cols;
}

function getDetailQuotaTableRow(data) {
   if(data) {
      let rows = [];
      for (let i = 0; i < data.length; ++i) {
         const row = {
            id: i,
            customerName: data[i].customerName,
            customerNumber: data[i].customerNumber,
            skuName: data[i].skuName,
            skuNumb: data[i].skuNumb,
            initialQuota: data[i].initialQuota,
            safetyMargin: data[i].safetyMargin,
            adjustment: data[i].adjustment,
            totalQuota: data[i].totalQuota,
         };
         rows.push(row);
      }
      return rows;
   }
   return [];
   
}
